<main role="main" *ngIf="!loading">
    <router-outlet #outlet="outlet"></router-outlet>
</main>
<div id="shell-loading" *ngIf="loading">
    <div class="page-loading-spinner">
        <mat-spinner color="primary" [diameter]="100"></mat-spinner>
    </div> 
</div>
<app-cookies></app-cookies>
